import React from "react";
import { DetailProps } from "../types";
import cx from "components/src/utils/cx";
import { IconProps } from "components/src/components/Icon/types";
import { Icon } from "../../Icon/Icon";
import { makeIcon } from "../js/makeIcon";
import { Divider } from "./Divider";
import { Badge } from "../../Badge/Badge";

export const Detail = ({
  tag,
  fgColor = "fg-moderate",
  textSize = "body-sm-bold",
  bgColor = "neutrals-transparent",
  leftIcon = "",
  leftBadge,
  rightIcon = "",
  dividerColor,
  showDivider = true,
  isFirst = false,
  isLast = false,
  padRight,
  noMargin,
  classes = "",
  allowTextWrap = false
}: DetailProps) => {
  let _leftIcon: IconProps | null = makeIcon(leftIcon) as IconProps;
  let _rightIcon: IconProps | null = makeIcon(rightIcon) as IconProps;
  const isClearOrDefaultBg = bgColor === "bg-default" || bgColor === "neutrals-transparent"
  const isBothFirstAndLast = isFirst && isLast;
  const hasClasses = !!classes;
  return (
    <>
        {showDivider && !isFirst ? <Divider dividerColor={dividerColor} /> : null}
        <span
          className={cx(
            {
              [textSize]: !!textSize,
              "cui-mx-1": !!bgColor && !isClearOrDefaultBg && !!!noMargin,
              "cui-px-1": !isFirst && !isLast && !hasClasses,
              "cui-pl-1": isLast && !isBothFirstAndLast && !hasClasses,
              "cui-pr-1": isFirst && !isBothFirstAndLast && !!!padRight && !hasClasses,
              "cui-py-0": !classes,
              "cui-pr-2xs": !!padRight,
              "cui-whitespace-nowrap": !allowTextWrap,
              [classes]: true
            },
            "cui-inline-flex cui-gap-1 cui-items-center cui-rounded-2px"
          )}
          style={{
            color: `var(--${fgColor})`,
            background: `var(--${bgColor})`,
          }}
        >
          {leftBadge ? <Badge {...leftBadge} /> : null} 
          {_leftIcon ? <Icon {..._leftIcon} /> : null}
          {tag}
          {_rightIcon ? <Icon {..._rightIcon} /> : null}
      </span>
    </>
  );
};
